module.exports = __webpack_public_path__ + "static/img/news_top_04_1.4af1f446.gif";